import axios from 'axios';

export class AxiosConfig {
    static init(baseUrl: string, authenticationToken: string) {
        axios.defaults.baseURL = baseUrl;
        axios.defaults.headers.common.Accept = 'application/json';
        axios.defaults.headers["Authorization"] = `Bearer ${authenticationToken}`;
    }
}